import { Component, Input } from '@angular/core';
import { Slide } from './slide.interface';
import { CarouselModule } from '@rogers/cdk/carousel';
import { PictureModule } from '@rogers/cdk/picture';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, CarouselModule, PictureModule],
  selector: 'ucx-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent {
  @Input() slides: Slide[] = [];
  @Input() slideLabel = '';
}
